import BalanceIndicator from "./balance_indicator";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { getStripeBalance } from "../../../actions/balance";

function mapStateToProps(state) {
  return {
    user: state.user.user,
    isLoading: state.balance.isLoading,
    balance: state.balance.balance,
    stripeBalance: state.balance.stripeBalance,
    stripeBalancePending: state.balance.stripeBalancePending,
  };
}

const mapDispatchToProps = {
  getStripeBalance,
};

const BalanceIndicatorWrapper = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BalanceIndicator)
);

export default BalanceIndicatorWrapper;
